import { useState } from "react";
import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
import "./ReactCalendar.css";

const ReactCalendar = () => {
  const [value, onChange] = useState(new Date());
  return (
    <div>
      <Calendar
        onChange={onChange}
        value={value}
        className="react-calendar-main"
      />
    </div>
  );
};

export default ReactCalendar;
